// eslint-disable-next-line no-unused-vars
import React, {useContext} from "react";
import {ConfigContext} from "./index";
import translations from "../../translations";

function LoggedIn() {
    const {
        config,
    } = useContext(ConfigContext);
    const customTextCandidateWidget = window["myTalentionConfig"]?.customTextCandidateWidget;
    const translation = translations[config.lang] ? translations[config.lang] : translations["de"];
    const HeadlineTag = customTextCandidateWidget?.htmlTagHeadline || "h2";
    const Intro = () => {
        return <header className={"tms-candidate-widget-login-header"}>
            <HeadlineTag>
                {translation.candidateWidgetLoggedInHeadline}
            </HeadlineTag>
        </header>;
    };

    return (
        <>
            <Intro/>
        </>

    );
}

export default LoggedIn;
